import { gql } from '@apollo/client';

export const OPERATORS_LOOKUP = gql`
  query OperatorsLookup($term: String!) {
    operatorsLookup(term: $term) {
      id
      name
    }
  }
`;

export const OPERATOR_LOOKUP = gql`
  query OperatorLookup($id: ID!) {
    operatorLookup(id: $id) {
      id
      name
      avfuelAccounts {
        name
        accountNumber
      }
    }
  }
`;